import React, { useState } from 'react'
import { CalenderIcon, CalculatorIcon, Arrow } from '../../Images/svgs';
import { useDispatch, useSelector } from 'react-redux';
import { toggleDropdown, setSelectedValue } from '../../Managment/Slice';
import DropDown from '../Partials/DropDown';

function MoneyZaka() {
    const [inputValue, setInputValue] = useState('');
    const [result, setResult] = useState(null);
    const [goldPrice, setGoldPrice] = useState(67);
    const [nisabReached, setNisabReached] = useState(null);
    const [nisabPrice, setnisabPrice] = useState(null)
    const [showWarning, setShowWarning] = useState(false);


    const handleInputChange = (event) => {
        setInputValue(event.target.value);
        setShowWarning(false);
    };

    const dispatch = useDispatch();
    const showlists = useSelector(state => state.dropdown.showlists);
    const selectedValues = useSelector(state => state.dropdown.selectedValues);

    const toggleDropDown = (index) => {
        dispatch(toggleDropdown({ index }));
    };

    const handleSelect = (value, index) => {
        dispatch(setSelectedValue({ index, value }));
    };



    const calculateResult = () => {
        if (!inputValue) {
            setShowWarning(true);
            return;
        }

        if (goldPrice && inputValue) {
            const nisab = goldPrice * 87.5
            setnisabPrice(nisab)
            if (inputValue >= nisab) {
                setNisabReached(true)
            } else {
                setNisabReached(false)
            }
        }


        if (selectedValues[0] === 'ميلادي') {
            const calculatedResult = (inputValue * 2.577) / 100;
            setResult(calculatedResult);

        } else {
            const calculatedResult = (inputValue * 2.5) / 100;
            setResult(calculatedResult);

        }

    }

    const year = [
        { text: 'ميلادي' },
        { text: 'هجري' }

    ];






    return (
        <>
            <div className="justify-end">
                <div className="flex gap-5 max-md:flex-col max-md:gap-0 max-md:">
                    <div className="flex flex-col ml-5 w-[67%] max-md:ml-0 max-md:w-full">
                        <div className="flex flex-col grow px-5 py-10 w-full text-sm bg-white rounded-xl border border-solid border-black border-opacity-20 max-md:mt-5 max-md:max-w-full">
                            <div className="self-start text-base font-medium whitespace-nowrap text-slate-700">
                                اختر السنة
                            </div>
                            <div className="relative flex gap-2 justify-between px-3.5 py-2.5 mt-1.5 text-sm font-medium leading-6 text-right bg-white rounded-lg border border-gray-300 border-solid shadow-sm text-neutral-900 max-md:flex-wrap max-md:max-w-full">
                                <input className='outline-none grow max-md:max-w-full'
                                    onClick={() => toggleDropDown(4)}
                                    value={selectedValues[0]}
                                    readOnly
                                    placeholder="هجري" />
                                <Arrow className="my-auto w-5 aspect-square" />
                                <DropDown links={year} isOpen={showlists[4]} onSelect={(value) => handleSelect(value, 0)} dropdownId={4} />
                            </div>
                            <div className="flex gap-2 justify-between px-3.5 py-2.5 mt-5 leading-6 text-right rounded-lg border border-gray-300 border-solid shadow-sm bg-stone-50 max-md:flex-wrap max-md:max-w-full">
                                <div className="grow text-gray-500 max-md:max-w-full">
                                    نسبة الزكاة حسب السنة التي قمت بإختيارها
                                </div>
                                <div className="font-bold text-blue-900">{selectedValues[0] === 'ميلادي' ? '0.0275%' : '2.5%'}</div>
                            </div>
                            <div className="self-start mt-5 text-base font-medium whitespace-nowrap text-slate-700">
                                المبلغ النقدي
                            </div>
                            <div className="flex gap-2 justify-end px-3.5 py-2.5 mt-1.5 font-medium leading-6 text-right whitespace-nowrap bg-white rounded-lg border border-gray-300 border-solid shadow-sm text-zinc-600 max-md:flex-wrap max-md:max-w-full">
                                <input className="grow max-md:max-w-full outline-none text-black"
                                    placeholder='00.00'
                                    type='number'
                                    value={inputValue}
                                    onChange={handleInputChange}
                                    required
                                />
                            </div>
                            {showWarning && (
                                <p className="mt-2 text-pink-600 text-lg">
                                    قيمة المبلغ النقدي فارغة
                                </p>
                            )}
                            {nisabReached === false &&
                                <p className="mt-2 text-pink-600 text-lg">
                                    {!nisabReached && `المبلغ أقل من قيمة النصاب ${Math.round(nisabPrice)}`}
                                </p>
                            }
                            <button className="justify-center self-start px-3.5 py-2 mt-10 font-medium whitespace-nowrap bg-amber-300 rounded-lg shadow-sm leading-[143%] text-neutral-900"
                                onClick={calculateResult}
                            >
                                احسب قيمة الزكاة
                            </button>
                        </div>
                    </div>

                    {nisabReached === true &&
                        <div className="flex flex-col w-[33%] max-md:ml-0 max-md:w-full">
                            <div className="flex flex-col px-5 py-10 mx-auto w-full rounded-2xl border border-solid bg-emerald-300 bg-opacity-20 border-[color:var(--Main-Colors-4,#54E8B2)] max-md:mt-5">
                                <CalculatorIcon
                                    className="self-start aspect-square w-[54px]"
                                />
                                <div className="mt-3 text-sm font-bold leading-6 text-right whitespace-nowrap text-neutral-900">
                                    قيمة الزكاة المراد اخراجها هي
                                </div>
                                <div className="mt-3 text-2xl font-bold leading-5 text-right text-black whitespace-nowrap">
                                    {result} دينار
                                </div>
                                <div className="flex gap-3 pl-20 mt-10 max-md:pl-5">
                                    <button className="justify-center px-3.5 py-2 text-sm font-medium leading-5 whitespace-nowrap bg-amber-300 rounded-lg shadow-sm text-neutral-900">
                                        اخرج زكاتك الان
                                    </button>
                                    <button className="flex justify-center items-center px-3.5 py-2 bg-blue-600 rounded-lg shadow-sm aspect-[1.33]">
                                        <CalenderIcon
                                            className="w-5 aspect-square"
                                        />
                                    </button>
                                </div>
                            </div>
                        </div>
                    }
                </div>
            </div>
        </>
    )
}

export default MoneyZaka